import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionQuery } from '../state/session/session.query';
import { map } from 'rxjs/operators';

/** AdminRoleGuard
 * @description This guard is used to protect routes that are only accessible to users with the role of 'admin'. It differs from the RoleGuard in that it only checks the primary user authority and not the authority of impersonated user if admin happens to impersonate another user.
 */
@Injectable({
    providedIn: 'root'
})
export class AdminRoleGuard implements CanActivate {
    constructor(private session: SessionQuery) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        return this.session.userRoles$.pipe(
            map((authorities) =>
                authorities
                    .filter((authority) => authority.includes('ROLE_'))
                    .map((authority) => authority.replace('ROLE_', ''))
                    .some((r) => route.routeConfig.data?.roles?.indexOf(r) >= 0)
            )
        );
    }
}
